import { Navigate, Route, Routes } from 'react-router-dom';
import { AppLayout } from '../../shared/components/Layout/AppLayout';
import { ProtectedRoute } from './ProtectedRoute';
import { LoginPage } from '../../modules/auth/LoginPage';
import { RegistrationPage } from '../../modules/auth/RegistrationPage';
import { DashboardPage } from '../../modules/dashboard/DashboardPage';
import { TenantsPage } from '../../modules/tenants/TenantsPage';
import { UsersPage } from '../../modules/users/UsersPage';
import { TagsPage } from '../../modules/tags/TagsPage';
import { ProjectsPage } from '../../modules/projects/ProjectsPage';
import { ProjectDetail } from '../../modules/projects/ProjectDetail';
import { ItemsPage } from '../../modules/items/ItemsPage';
import { ItemDetailPage } from '../../modules/items/ItemDetailPage';
import { ItemDetailsPage } from '../../modules/item-details/ItemDetailsPage';
import { GlobalSettingsLayout } from '../../modules/global-settings/GlobalSettingsLayout';
import { DocumentManagementPage } from '../../modules/global-settings/DocumentManagementPage';
import { DocumentTypeDetailPage } from '../../modules/global-settings/DocumentTypeDetailPage';
import { AiAssistantRolesPage } from '../../modules/global-settings/AiAssistantRolesPage';
import { AiAssistantRoleDetailPage } from '../../modules/global-settings/AiAssistantRoleDetailPage';
import { EntityTypeSkillsPage } from '../../modules/global-settings/EntityTypeSkillsPage';
import { EntityTypesPage } from '../../modules/global-settings/EntityTypesPage';
import { PromptMonitoringPage } from '../../modules/prompt-monitoring/PromptMonitoringPage';
import { JobMonitoringPage } from '../../modules/job-monitoring/JobMonitoringPage';
import { AiChatMonitoringPage } from '../../modules/ai-chat-monitoring/AiChatMonitoringPage';
import { AiChatSessionDetailPage } from '../../modules/ai-chat-monitoring/AiChatSessionDetailPage';

export function AppRouter() {
  return (
    <Routes>
      <Route path="/login" element={<LoginPage />} />
      <Route path="/register" element={<RegistrationPage />} />
      <Route element={<ProtectedRoute />}>
        <Route element={<AppLayout />}>
          <Route path="/" element={<DashboardPage />} />
          <Route path="/tenants" element={<TenantsPage />} />
          <Route path="/users" element={<UsersPage />} />
          <Route path="/tags" element={<TagsPage />} />
          <Route path="/projects" element={<ProjectsPage />} />
          <Route path="/projects/:id" element={<ProjectDetail />} />
          <Route path="/items" element={<ItemsPage />} />
          <Route path="/items/:id" element={<ItemDetailPage />} />
          <Route path="/item-details" element={<ItemDetailsPage />} />

          {/* Global Settings section */}
          <Route path="/global-settings" element={<GlobalSettingsLayout />}>
            <Route path="document-management" element={<DocumentManagementPage />} />
            <Route path="document-types/:id" element={<DocumentTypeDetailPage />} />
            <Route path="ai-assistant-roles" element={<AiAssistantRolesPage />} />
            <Route path="ai-assistant-roles/:id" element={<AiAssistantRoleDetailPage />} />
            <Route path="entity-type-skills" element={<EntityTypeSkillsPage />} />
            <Route path="entity-types" element={<EntityTypesPage />} />
          </Route>

          <Route path="/prompt-monitoring" element={<PromptMonitoringPage />} />
          <Route path="/job-monitoring" element={<JobMonitoringPage />} />
          <Route path="/ai-chat-monitoring" element={<AiChatMonitoringPage />} />
          <Route path="/ai-chat-monitoring/:id" element={<AiChatSessionDetailPage />} />

          <Route path="*" element={<Navigate to="/" replace />} />
        </Route>
      </Route>
    </Routes>
  );
}
